import { api } from "./axios";

export function generateKYCLink(investmentAccountId: string): Promise<{
  metadata: { requestId: string };
  result: {
    startKycUrl: string;
  };
  status: string;
  statusCode: number;
}> {
  return api.post("hyperverge/onboarding_link/", {
    investment_account_guid: investmentAccountId,
  });
}

export function getKYCResults(payload: {
  investmentAccountId: string;
  addDelay: boolean;
}) {
  return api.post("hyperverge/results/", {
    investment_account_guid: payload.investmentAccountId,
    add_delay: payload.addDelay,
  });
}

export function sendKycEmail(investmentAccountId: string) {
  return api.post("hyperverge/send-kyc-completion-email/", {
    investment_account_guid: investmentAccountId,
  });
}

export function getKycIds(
  investmentAccountId: string
): Promise<{ transaction_id: string; unique_id: string }> {
  return api.get("hyperverge/get-hyperverge-ids/", {
    params: {
      investment_account_guid: investmentAccountId,
    },
  });
}
